import moment from "moment"

moment.locale("pt-BR")

export default moment
